export default __webpack_public_path__ + "static/media/SWT1810.34I-39821_-23653_0.f14935b4.jpg";